import { useQuery, UseQueryOptions } from "react-query";
import { IRequest } from "../interfaces/authentication.interface";
import { ICountry } from "../interfaces/countries.interface";
import { getCountries } from "../services/countries.service";

export function useCountries<T extends any = IRequest<ICountry[]>>(
    locale: string,
    options?: UseQueryOptions<any, unknown, T>
) {
    return useQuery({
        queryKey: ["countries", locale],
        queryFn: () => getCountries(locale),
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        ...options
    });
}
